export default __webpack_public_path__ + "static/media/space-bg.bf39d6f4.svg";